/* Title Finder — default the UI to a sellable state (go-live 2026-09-01)
 * Companion to tf-live-states.js, which blocks the states CITEC has not released.
 * This file fixes the other half: every state selector on the homepage opened on
 * QLD, a blocked state, and the main nav sent everyone to the QLD-only collection
 * page. A visitor from SA, TAS, ACT or NT had no path to a product they can buy.
 *
 * There are THREE state selectors, not one: the hero reference search
 * (.tf-hero__state-pill), the product finder (.tf-qpill) and the pricing table
 * (.tf-ptab). Each has its own click handler, so we call the theme's own function
 * for each rather than faking the class — that keeps whatever else the handler
 * updates in sync.
 *
 * Loaded from snippets/header.liquid, which runs on every page.
 */
(function () {
  "use strict";

  var LIVE = ["sa", "tas", "act", "nt"];
  var GATED = ["qld", "vic", "wa"];
  var ORDER = LIVE.concat(GATED);
  var DEFAULT_STATE = "sa";

  /* Sellable states first. Reordering is done in the DOM, once per element set. */
  function reorder(selector, flag) {
    var els = document.querySelectorAll(selector);
    if (!els.length) return null;
    var parent = els[0].parentNode;
    if (!parent || parent.getAttribute(flag)) return els;
    var byState = {};
    els.forEach(function (el) { byState[el.getAttribute("data-state")] = el; });
    ORDER.forEach(function (st) { if (byState[st]) parent.appendChild(byState[st]); });
    parent.setAttribute(flag, "1");
    return document.querySelectorAll(selector);
  }

  /* A state the visitor chose before wins, but only if it is actually sellable.
   * NSW is discontinued and QLD/VIC/WA cannot be bought yet, so anything else
   * falls back to SA instead of opening on a state with no buy button. */
  function preferredState() {
    var saved = null;
    try { saved = localStorage.getItem("tf_state"); } catch (e) {}
    saved = saved ? String(saved).toLowerCase() : null;
    return (saved && LIVE.indexOf(saved) !== -1) ? saved : DEFAULT_STATE;
  }

  function activate(selector, activeClass, flag, invoke) {
    var els = reorder(selector, flag);
    if (!els || !els.length) return;
    var state = preferredState();
    var already = false;
    els.forEach(function (el) {
      if (el.classList.contains(activeClass) && el.getAttribute("data-state") === state) already = true;
    });
    if (already) return;
    var target = null;
    els.forEach(function (el) { if (el.getAttribute("data-state") === state) target = el; });
    if (!target) return;
    try { invoke(target, state); } catch (e) {
      els.forEach(function (el) { el.classList.remove(activeClass); });
      target.classList.add(activeClass);
    }
  }

  function applyDefaults() {
    /* Hero reference search */
    activate(".tf-hero__state-pill", "active", "data-tf-order-hero", function (el) {
      if (typeof window.tfStatePill === "function") window.tfStatePill(el);
      else throw new Error("no handler");
    });

    /* Product finder pills */
    activate(".tf-qpill", "tf-qpill--active", "data-tf-order-quiz", function (el) {
      if (typeof window.tfQuizState === "function") window.tfQuizState(el);
      else throw new Error("no handler");
    });

    /* Pricing table tabs */
    activate(".tf-ptab", "tf-ptab--active", "data-tf-order-price", function (el, state) {
      if (typeof window.switchState === "function") window.switchState(state);
      else throw new Error("no handler");
    });
  }

  /* Main nav: the TITLES item points at /collections/titles, a Queensland-only
   * landing page whose products cannot be bought right now. Send it to the state
   * chooser on the homepage instead. The collection page is untouched and stays
   * indexed — only the nav link moves. */
  function retargetNav() {
    document.querySelectorAll('.t4s-nav__ul a[href*="/collections/titles"]').forEach(function (a) {
      if (a.getAttribute("data-tf-retargeted")) return;
      a.setAttribute("href", "/#pricing-tabs");
      a.setAttribute("data-tf-retargeted", "1");
      var label = a.querySelector("span") || a;
      if (/^\s*TITLES\s*$/i.test(label.textContent)) label.textContent = "TITLE SEARCHES";
    });
  }

  function run() {
    try { applyDefaults(); } catch (e) {}
    try { retargetNav(); } catch (e) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();

  /* The homepage sections set their own defaults on their own DOMContentLoaded
   * handlers, so re-apply after them. */
  window.addEventListener("load", run);
  setTimeout(run, 300);
  setTimeout(run, 1200);
})();
